import { SET_TRACKER } from './constants';

export const setTracker = tracker => ({
  type: SET_TRACKER,
  payload: tracker,
});

// Async action to load initial tracker value from localStorage
export const loadTrackerFromLocalStorage = () => dispatch => {
  const savedTracker = localStorage.getItem('activeTracker') || 'habit';
  dispatch(setTracker(savedTracker));
};
